import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import axios from 'axios';
import * as moment from 'moment';
import { IMyDpOptions } from 'mydatepicker';
import {API_BASE_URL, ENDPOINTS, USER_ROLES} from '../app.config';
import Utils from '../app.utilities';
import { CompanyService } from '../company.service';

const utilities = new Utils();

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css'],
})
export class HelpComponent implements OnInit {
  linuxVersion: string = '...';
  windowsVersion: string = '...';

  constructor() {
    
  }

  ngOnInit() {
    const self = this;
    axios.get(ENDPOINTS.VERSION)
      .then(response => {
        self.linuxVersion = response.data.updates.linux['latest-version'];
        self.windowsVersion = response.data.updates.windows['latest-version'];
      }, error => {

      });
  }
}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/help/help.component.ts